import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    customer: { type: "Offline", custType: 'local' },
    phone1: { phone: '', priority: 1, type: 'normal', code: '+91', status: false, otp: '', otpSent: false, disable: false, load: false },
    phone2: { phone: '', code: '+91', priority: 2, type: 'normal', status: false, otp: '', load: false, otpSent: false, disable: false },
    phone3: { phone: '', code: '+91', priority: 3, load: false, type: 'normal', status: false, otp: '', otpSent: false, disable: false },
    dl: { dl: "", dlDate: "", dlStatus: false, dl_back_photo: "", dl_photo: "", dlPhoto: "", dlBackPhoto: "" },
    passport: { passport: "", passportDate: "", passportName: "", passportStatus: false, passport_photo_1: "", passport_photo: "", passportPhoto: "", passportPhoto1: "", passport_photo_2: "", passportPhoto2: "" },
    aadhaar: { aadhaar: "", decentroId: "", phoneNo: "", reference_id: false, aadhaar_back_photo: "", aadhaar_photo: "", aadhaarPhoto: "", aadhaarBackPhoto: "", otp: "", aadhaarStatus: false, otpSent: false, disable: false },
    secDl: { dob: "", dl: "", dlDate: "", dlStatus: false, dl_back_photo: "", dl_photo: "", dlPhoto: "", dlBackPhoto: "" },
    secPassport: { dob: "", passport: "", passportDate: "", passportName: "", passportStatus: false, passport_photo_1: "", passport_photo: "", passportPhoto: "", passportPhoto1: "", passport_photo_2: "", passportPhoto2: "" },
    secAadhaar: { aadhaar: "", decentroId: "", phoneNo: "", reference_id: false, aadhaar_back_photo: "", aadhaar_photo: "", aadhaarPhoto: "", aadhaarBackPhoto: "", otp: "", aadhaarStatus: false, otpSent: false, disable: false },
    step: 0,
    accept: false,
    checkAccept: false,
    tempAddress: { line1: "", line2: "", area: "", city: "", pincode: "", country: "", state: "" },
    perAddress: { line1: "", line2: "", area: "", city: "", pincode: "", country: "", state: "" },
    secDetails: {name: "", dob: ""}
};

const customerSlice = createSlice({
    name: "customer",
    initialState,
    reducers: {
        setCustomer: (state, { payload }) => {
            state.customer = { ...state.customer, ...payload }
        },
        setSecDetails: (state, { payload }) => {
            state.secDetails = { ...state.secDetails, ...payload }
        },
        setPhone1: (state, { payload }) => {
            state.phone1 = { ...state.phone1, ...payload }
        },
        setPhone2: (state, { payload }) => {
            state.phone2 = { ...state.phone2, ...payload }
        },
        setPhone3: (state, { payload }) => {
            state.phone3 = { ...state.phone3, ...payload }
        },
        setDl: (state, { payload }) => {
            state.dl = { ...state.dl, ...payload }
        },
        setPassport: (state, { payload }) => {
            state.passport = { ...state.passport, ...payload }
        },
        setAadhaar: (state, { payload }) => {
            state.aadhaar = { ...state.aadhaar, ...payload }
        },
        setSecDl: (state, { payload }) => {
            state.secDl = { ...state.secDl, ...payload }
        },
        setSecPassport: (state, { payload }) => {
            state.secPassport = { ...state.secPassport, ...payload }
        },
        setSecAadhaar: (state, { payload }) => {
            state.secAadhaar = { ...state.secAadhaar, ...payload }
        },
        setTempAddress: (state, { payload }) => {
            state.tempAddress = { ...state.tempAddress, ...payload }
        },
        setPerAddress: (state, { payload }) => {
            state.perAddress = { ...state.perAddress, ...payload }
        },
        setStep: (state, { payload }) => {
            state.step = payload
        },
        setCheckAccept: (state, { payload }) => {
            state.checkAccept = payload
        },
        setAccept: (state, { payload }) => {
            state.accept = payload
        },
        clearAll: () => initialState
    }
});

export const { setAadhaar, setCustomer,setSecDetails, setTempAddress, setPerAddress, setDl, setAccept, setCheckAccept, setPassport, setPhone1, setPhone2, setPhone3, setSecAadhaar, setSecDl, setSecPassport, setStep, clearAll } = customerSlice.actions
export default customerSlice.reducer;
